module.exports = __webpack_public_path__ + "img/valance-french.3a7c79fb.svg";